import { IoDocumentOutline } from 'react-icons/io5';

interface IImageComponent {
  image?: string;
}
function ImageComponent({ image }: IImageComponent) {
  if (image && !image.includes('undefined')) {
    if (
      image.endsWith('.png') ||
      image.endsWith('.jpg') ||
      image.endsWith('.jpeg') ||
      image.endsWith('.webp')
    ) {
      return <img src={image} className="object-cover object-center h-full w-full" alt="" />;
    }
    return (
      <div className="flex flex-col items-center justify-center object-cover object-center border border-slate-200 rounded-3xl p-1 overflow-hidden">
        <IoDocumentOutline className="text-6xl" />
        <div className="text-center text-wrap text-ellipsis">
          {(image.match(/[^/]+$/)?.[0] ?? '').substring(0, 12)}
          &hellip;
          {image.match(/\..*?$/)?.[0]}
        </div>
      </div>
    );
  }

  return (
    <img src="/images/fallback.jpg" className="object-cover object-center h-full w-full" alt="" />
  );
}

export default ImageComponent;
